import React, { useEffect, useState } from 'react'
import { ConnectGoLogicPlatform } from 'components/FakePlaysComponent/style'
import InputField from 'components/Common/InputField'
import Button from 'components/Common/Button'
import UploadFiles from 'components/Common/Upload/UploadFiles'
import PlaySuccessCard from 'components/Owner/Plays/PlaySuccessCard'

import {
  checkError,
  createResponse,
  getDefaultValue,
  getErrorMessage,
  openNewWindow,
} from 'utils/helper'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { FORM, STATUS, supportedPlayIds } from 'config'
import { isEmpty } from 'lodash'
import { get } from 'lodash'
import SelectField from 'components/Common/SelectField'
import { disablePlayButton, IOption, isValueExist } from 'components/Owner/Plays/utils'
import { yearOptions } from 'utils/helper'
import useFormContainer from 'hooks/useFormContainer'
import hookForms from 'utils/hookForms'
import Block from 'components/Owner/Tools/Block'
import uuid from 'react-uuid'
import UploadSuccessScreen from 'components/Assessment/AssessmentQuestion/UploadSuccessScreen'
import { CustomFile } from 'types'
import { Tool, ToolSupportLevel } from '__generated__/api-types-and-hooks'
import ErrorMessage from 'components/Common/ErrorMessage'

export enum PLAY_STEP_TYPE {
  INPUT = 'input',
  UPLOAD = 'upload',
  AUTHENTICATION = 'authentication',
  CONNECTION = 'connection',
  SELECT = 'select',
}

const PlaysAuthentication = ({
  data,
  getErrors,
  getConnectedPlayAction,
  oAuthUrl,
  handleCyclrOAuthAction,
  moveNext,
  playStage,
  isConnected,
  setActiveConnectingTool,
  getUserConnectorsAction,
  resetOAuthUrlAction,
  handleCloseAuth,
  playData,
  user,
  isPlayDataSaving,
  savePlayDataAction,
  playValue,
  isPlayCompleted,
  uploadFileAction,
  uploadedFile,
  uploadFileErrors,
  getOAuthUrlAction,
  uploadFileLoading,
  playId,
  saveUserPlayFileAction,
  tabIndex,
  stepIndex,
  stepDataIndex,
  resetUploadFileAction,
  savePlayDataError,
  resetSavePlayDataError,
  isPlayResponseLoading,
  playResponse,
  setToolConnectionStatus,
}) => {
  const methods = useForm({
    mode: 'onBlur',
    // resolver: yupResolver(getSchema(data?.meta?.toolName), { abortEarly: false }),
  })
  const { register, handleSubmit, control } = methods
  const [showUploadModal, setShowUploadModal] = useState(false)

  useEffect(() => {
    if (!supportedPlayIds.includes(playId)) {
      if (data.stepType === PLAY_STEP_TYPE.INPUT || data.stepType === PLAY_STEP_TYPE.UPLOAD) {
        getConnectedPlayAction({
          type: playData?.recommendedBy?.type,
          question: playData?.meta?.questionType,
        })
      } else if (data.stepType === PLAY_STEP_TYPE.AUTHENTICATION) {
        setActiveConnectingTool(data?.meta)
        getConnectedPlayAction({
          type: playData?.recommendedBy?.type,
          question: data?.stepBody[0]?.questionType,
          url: data?.meta?.authenticationUrl,
        })
        if (oAuthUrl) {
          openNewWindow(oAuthUrl, false)
        }
      } else if (data.stepType === PLAY_STEP_TYPE.CONNECTION) {
        setActiveConnectingTool(data?.meta)
      }
    }
    return () => resetSavePlayDataError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const onSubmit = (formData) => {
    playStage.isCompleted = true
    let assessmentResponseObj = {
      userId: user?.id,
      type: playData?.recommendedBy?.type,
      assessmentResponse: createResponse(data?.stepBody, formData, playData),
    }
    savePlayDataAction({
      question: data?.stepBody[0].questionType,
      assessmentResponseObj: assessmentResponseObj,
    })
  }
  useFormContainer(FORM.PLAY_FORM, methods)

  const form = hookForms?.getForm(FORM.PLAY_FORM)
  const formValue = form?.getValues()

  const tool: Tool = {
    userToolsImageUrl: playData?.meta?.userToolsImageUrl,
    toolUrl: playData?.meta?.toolUrl,
    toolDisplayName: playData?.meta?.toolDisplayName,
    toolName: playData?.meta?.toolName,
    cyclrToolId: playData?.meta?.cyclrToolId,
    isConnected: isConnected,
    supportLevel: playData.meta?.supportLevel || ToolSupportLevel.Open,
  }
  const toolId = playData?.meta?.toolId || uuid()
  let exceptionValues: string[] = []

  const getFiles = (files: CustomFile) => {
    saveUserPlayFileAction({
      saveFile: true,
      isMultiple: false,
      tabIndex,
      stepIndex,
      stepDataIndex,
      tabId: playData.playTabs[tabIndex].id,
      stepData: {
        id: playData.playTabs[tabIndex].tabData.steps[stepIndex].stepData[stepDataIndex].id,
        isCompleted: false,
      },
      generationNotification: false,
      files,
    })
  }
  const uploadFile = (files: CustomFile) => {
    uploadFileAction({
      files,
      saveFile: true,
    })
  }
  return (
    <>
      {savePlayDataError && <ErrorMessage id={'play-view'}>{savePlayDataError}</ErrorMessage>}
      {(data.stepType === PLAY_STEP_TYPE.AUTHENTICATION ||
        data.stepType === PLAY_STEP_TYPE.INPUT) &&
        !isConnected &&
        !isPlayResponseLoading && (
          <div>
            {data?.stepHeading?.title}
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <ConnectGoLogicPlatform>
                  {!isConnected &&
                    data.stepBody.map((body, index) => {
                      const regex: any = body?.regex ? new RegExp(body?.regex.trim()) : undefined
                      const errorMessage = get(body, 'errorMessage', '')
                      const options: IOption[] = !isEmpty(body?.options)
                        ? body?.options
                        : yearOptions()

                      exceptionValues = [
                        ...exceptionValues,
                        body?.exceptionValue ? body.exceptionValue : '',
                      ]
                      const isError = checkError(regex, formValue[body?.fieldName], false)
                      return (
                        <div className="w-full max-w-[500px] connectGologinWrap">
                          <div className="text-center">
                            <label className="text-4xl font-normal font-primary">
                              {body?.title}
                            </label>
                          </div>
                          <div className="text-primary-text font-normal text-base text-center mt-6 mb-6">
                            {body?.description}
                          </div>
                          <div className="mb-6">
                            {body?.type === PLAY_STEP_TYPE.INPUT && (
                              <InputField
                                placeholder={body.placeholder}
                                type={body?.inputType}
                                mask={data?.meta?.mask}
                                label={body.label}
                                className="mb-4"
                                {...register(`${body?.fieldName}`)}
                                defaultValue={
                                  playResponse ? getDefaultValue(playResponse, body.fieldName) : ''
                                }
                                errors={
                                  isError
                                    ? {
                                        message: errorMessage
                                          ? errorMessage
                                          : getErrorMessage(body.label),
                                      }
                                    : ''
                                }
                                disabled={isPlayCompleted}
                              />
                            )}
                            {body?.type === PLAY_STEP_TYPE.SELECT && (
                              <Controller
                                name={`${body.questionType}`}
                                control={control}
                                render={({ field }) => (
                                  <SelectField
                                    {...field}
                                    placeholder={body.placeholder}
                                    label={body.label}
                                    className="mb-4"
                                    disable={isPlayCompleted}
                                    options={options}
                                    errors={getErrors(formValue, body)}
                                  />
                                )}
                              />
                            )}
                          </div>
                          {index === data.stepBody.length - 1 && (
                            // check-button - clean up custom px
                            <Button
                              label="Submit"
                              type="submit"
                              variant="primary"
                              className="px-3 w-full"
                              disabled={
                                isPlayCompleted ||
                                isPlayDataSaving ||
                                disablePlayButton(formValue, isError, exceptionValues)
                              }
                              status={isPlayDataSaving ? STATUS.LOADING : ''}
                            />
                          )}
                        </div>
                      )
                    })}
                </ConnectGoLogicPlatform>
              </form>
            </FormProvider>
          </div>
        )}
      {data.stepType === PLAY_STEP_TYPE.CONNECTION && (
        <>
          {data?.stepHeading?.title}
          <Block
            allowDisconnect={false}
            key={toolId}
            tool={tool}
            getOAuthUrlAction={getOAuthUrlAction}
            onDisconnect={() => {
              setToolConnectionStatus({
                toolName: tool.toolName,
                isConnected: false,
              })
            }}
          />
        </>
      )}
      {data.stepType === PLAY_STEP_TYPE.UPLOAD &&
        !supportedPlayIds.includes(playId) &&
        isEmpty(playValue) && (
          <>
            <ConnectGoLogicPlatform>
              <UploadFiles
                uploadFileLoading={uploadFileLoading}
                showCloseButton={false}
                showUploadModal={showUploadModal}
                uploadType={data?.meta?.uploadType}
                uploadFileErrors={uploadFileErrors}
                setShowUploadModal={setShowUploadModal}
                fileExtensions={data?.meta?.fileExtension}
                userId={user?.id}
                uploadedFile={uploadedFile}
                isBorderVariantChanged={false}
                getFiles={uploadFile}
                resetUploadFileAction={resetUploadFileAction}
              />
            </ConnectGoLogicPlatform>
          </>
        )}
      {data.stepType === PLAY_STEP_TYPE.UPLOAD &&
        supportedPlayIds.includes(playId) &&
        !isValueExist(playStage, tabIndex, stepIndex, stepDataIndex) && (
          <>
            <ConnectGoLogicPlatform>
              <UploadFiles
                uploadFileLoading={uploadFileLoading}
                showCloseButton={false}
                showUploadModal={showUploadModal}
                uploadType={data?.meta?.uploadType}
                uploadFileErrors={uploadFileErrors}
                setShowUploadModal={setShowUploadModal}
                fileExtensions={data?.meta?.fileExtension}
                userId={user?.id}
                uploadedFile={uploadedFile}
                isBorderVariantChanged={false}
                getFiles={getFiles}
                resetUploadFileAction={resetUploadFileAction}
              />
            </ConnectGoLogicPlatform>
          </>
        )}
      {data.stepType === PLAY_STEP_TYPE.UPLOAD &&
        supportedPlayIds.includes(playId) &&
        isValueExist(playStage, tabIndex, stepIndex, stepDataIndex) &&
        playStage[tabIndex].steps[stepIndex]?.stepData[stepDataIndex]?.value?.map((val: string) => (
          <UploadSuccessScreen selectedOption={{ url: val }} uploadType={data?.meta?.uploadType} />
        ))}
      {!supportedPlayIds.includes(playId) && (
        <PlaySuccessCard
          data={data}
          userId={user?.id}
          playData={playData}
          moveNext={moveNext}
          playValue={playValue}
          isConnected={isConnected}
          uploadedFile={uploadedFile}
          isPlayCompleted={isPlayCompleted}
          savePlayDataAction={savePlayDataAction}
        />
      )}
    </>
  )
}

export default PlaysAuthentication
